import React, { useState, useEffect } from "react";
import parse from "html-react-parser";
import left from "../../assests/icons/left.png";
import right from "../../assests/icons/right.png";

const Slider = ({ slides, autoplay = true, autoplaySpeed = 3000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoplaying, setIsAutoplaying] = useState(autoplay);

  const goToNext = () => {
    setCurrentIndex(
      slides ? (prevIndex) => (prevIndex + 1) % slides.length : 0
    );
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      slides ? (prevIndex - 1 + slides.length) % slides.length : 0
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    if (isAutoplaying) {
      const interval = setInterval(goToNext, autoplaySpeed);
      return () => clearInterval(interval);
    }
  }, [isAutoplaying, autoplaySpeed]);

  return (
    slides && (
      <div className="slider">
        <div className="slider-content">
          {slides.length > 1 && (
            <img
              className="img prev-btn"
              onClick={goToPrevious}
              src={left}
              width={40}
              height={40}
            />
          )}
          <div className="slide">
            {slides[currentIndex] && parse(slides[currentIndex])}
          </div>
          {slides.length > 1 && (
            <img
              className="img next-btn"
              onClick={goToNext}
              src={right}
              width={40}
              height={40}
            />
          )}
        </div>
        {slides.length > 1 && (
          <div className="dots-navigation">
            {slides.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentIndex ? "active" : ""}`}
                onClick={() => goToSlide(index)}
              ></button>
            ))}
          </div>
        )}
      </div>
    )
  );
};

export default Slider;
